import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

import { WEBAPP_VERSION } from '../version'
import { getEnvironmentBasedOnRootApiUrl } from '../utils'

export const initDatadog = () => {
  if (
    !import.meta.env.REACT_APP_DATADOG_APPLICATION_ID ||
    !import.meta.env.REACT_APP_DATADOG_CLIENT_TOKEN
  ) {
    return
  }

  const environment = getEnvironmentBasedOnRootApiUrl()

  datadogRum.init({
    applicationId: import.meta.env.REACT_APP_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'tap3-webapp',
    env: environment,
    version: WEBAPP_VERSION,
    // % of total user sessions to capture
    sessionSampleRate: Number(import.meta.env.REACT_APP_DATADOG_SESSION_SAMPLE_RATE) || 10,
    // % of captured user sessions that should include Session Replay
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackBfcacheViews: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [/^https:\/\/[^]+\.microstarlogistics\.com/],
  })

  datadogLogs.init({
    clientToken: import.meta.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'tap3-webapp',
    env: environment,
    version: WEBAPP_VERSION,
    forwardErrorsToLogs: true,
    sessionSampleRate: Number(import.meta.env.REACT_APP_DATADOG_SESSION_SAMPLE_RATE) || 10,
  })
}
